import React, { useEffect, useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from 'recharts';

const Statistics = () => {
    const [screenWidth, setScreenWidth] = useState(800);
    useEffect(() => {
        const setWidth = () => {
            if (window.screen.width > 800) {
                setScreenWidth(800)
            }
            else {
            setScreenWidth(window.screen.width)
                
            }
        }
        setWidth()
        window.addEventListener('resize',setWidth)
    },[])
    let mainData = useLoaderData();
    let data = mainData.data; 
    return (
        <div className='statistics-container'>
            <h1 className='text-2xl font-semibold py-2 px-4 md:px-20 bg-blue-400 border-2 border-blue-800 my-4 w-fit mx-auto rounded'>Quiz Statistics</h1>
            <div className='w-11/12 mx-auto py-12 flex justify-center'>

                <BarChart
                    
                    width={screenWidth}
                    height={300}
                    data={data}
                    margin={{
                        top: 5,
                        right: 40,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="total" fill="#8884d8" background={{ fill: '#eee' }} />

                </BarChart>

            </div> </div>
    );
};

export default Statistics;